<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md class="subnav__reduced-padding">
    <sbnb-back-button style="margin-bottom: 20px"></sbnb-back-button>

    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'gx-question-detail'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs class="block sbnbDesktop:hidden"></sbnb-page-header>
    </app-feature-flag-tabs>
    <div *ngIf="loading" class="table__no-items">Loading question intent details...</div>

    <ng-container *ngIf="!loading && intentData">
      <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px" class="header__container">
        <div fxFlex fxLayoutAlign="start center" fxLayoutGap="8px">
          <h2 class="nomargin" fxLayoutAlign="start center" fxLayoutGap="16px">
            {{ intentData.name }}
          </h2>
        </div>
        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>

      <div class="rule__section-container" style="margin-top: 0">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" class="not-clickable">
            <img src="/assets/iconography/question.svg" />
            <span>Example questions</span>
            <span *ngIf="intentData.is_custom" class="card__collapsed-helper-text">
              Provide examples to help AI understand guest questions.
            </span>
          </h3>
        </div>

        <div style="margin-bottom: 20px">
          <ng-container *ngFor="let que of intentData.examples; let i = index; trackBy: trackByIndex">
            <input
              *ngIf="i < examplesShown"
              class="questions__example-input text__small"
              [disabled]="!intentData.is_custom"
              [(ngModel)]="intentData.examples[i]"
              placeholder="Write an example question"
              (blur)="exampleBlur()"
              (keyup.enter)="exampleBlur(); addAnotherSample()" />
          </ng-container>

          <button
            *ngIf="examplesShown < intentData.examples.length"
            mat-flat-button
            class="button__text"
            (click)="examplesShown = examplesShown + 5">
            Show 5 more...
          </button>

          <button
            *ngIf="intentData.is_custom"
            type="submit"
            mat-flat-button
            class="button__text"
            (click)="addAnotherSample()">
            Add another example question
          </button>
        </div>
      </div>

      <div class="rule__section-container" style="margin-top: 0">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" (click)="toggleCard('test')">
            <sbnb-icon icon="cog" class="shrink-0 text-smoke-darker"></sbnb-icon>
            <span>Test</span>
            <span class="card__collapsed-helper-text">
              Write an example message to test if AI detects your question.
            </span>
          </h3>
        </div>

        <div>
          <textarea class="question__test-textarea" [(ngModel)]="testString"></textarea>

          <div fxLayout fxLayoutAlign="space-between center">
            <div *ngIf="!lastDetectResults"></div>
            <div *ngIf="lastDetectResults && lastDetectResults.length === 0">No questions found</div>
            <div *ngIf="lastDetectResults && lastDetectResults.length > 0">
              <span>
                {{ lastDetectResults.length }} question{{ lastDetectResults.length > 1 ? 's' : '' }}
                detected:
              </span>
              <span *ngFor="let res of lastDetectResults; let isLast = last" class="ocean">
                {{ res }}{{ !isLast ? ', ' : '' }}
              </span>
            </div>
            <button
              [disabled]="detectInProgress"
              type="submit"
              mat-flat-button
              class="button__small"
              (click)="detect()">
              Detect questions
              <mat-spinner *ngIf="detectInProgress" class="button__spinner" diameter="16"></mat-spinner>
            </button>
          </div>
        </div>
      </div>

      <div class="rule__section-container">
        <div fxLayout fxLayoutAlign="start center">
          <h3 fxFlex fxLayoutAlign="start center" fxLayoutGap="8px" (click)="toggleCard('related')">
            <img src="/assets/iconography/nav-rule-manager.svg" />
            <span>Related Rules</span>
            <span class="card__collapsed-helper-text">
              These are the rules that will be triggered when this question is detected.
            </span>
          </h3>
        </div>

        <div>
          <div *ngIf="rulesetsData && rulesetsData.length === 0" class="table__no-items">
            No associated rules found for this intent.
          </div>
          <ng-container *ngIf="rulesetsData.length > 0">
            <div
              *ngFor="let rule of rulesetsData"
              class="question__rule-container"
              fxLayout
              fxLayoutAlign="start center"
              fxLayoutGap="12px"
              (click)="openRuleset(rule)">
              <div fxLayout fxLayoutAlign="start center" fxLayoutGap="8px" fxFlex>
                <mat-slide-toggle
                  [checked]="rule.active"
                  (change)="activateOrDeactivateRule(rule, $event)"
                  (click)="$event.stopPropagation()"></mat-slide-toggle>
                <span fxFlex class="question__rule-title cera-heading">{{ rule.name }}</span>
              </div>
              <div fxHide.lt-md fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
                <sbnb-icon icon="time" class="shrink-0 text-smoke-darker"></sbnb-icon>
                <span class="text__small cera-heading">{{ rule.event_short }}</span>
              </div>
              <div fxFlex.gt-sm fxFlex="none" fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
                <sbnb-icon icon="properties" [size]="20" class="shrink-0 text-smoke-darker"></sbnb-icon>
                <span>{{ rule.all_properties ? 'All' : rule.properties.length }}</span>
              </div>
              <div fxHide.lt-md fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
                <img style="width: 20px; height: 20px" src="/assets/iconography/nav-team.svg" alt="hosts" />
                <span>
                  {{ rule.all_hosts ? 'All' : rule.active_hosts_count ? rule.active_hosts_count : rule.hosts.length }}
                </span>
              </div>
              <div fxHide.lt-md fxLayout fxLayoutAlign="start center" fxLayoutGap="8px">
                <sbnb-icon-homeaway
                  [muted]="(rule | doesRuleHavePlatform: 'homeaway') ? false : true"></sbnb-icon-homeaway>
                <sbnb-icon-airbnb [muted]="(rule | doesRuleHavePlatform: 'airbnb') ? false : true"></sbnb-icon-airbnb>
                <sbnb-icon-booking
                  [muted]="(rule | doesRuleHavePlatform: 'booking') ? false : true"></sbnb-icon-booking>
              </div>
            </div>
          </ng-container>

          <button class="button__text" mat-flat-button (click)="createQuestionRule(intentData)">+ Add a rule</button>
        </div>
      </div>

      <div class="rule__section-container" fxLayout fxLayoutAlign="start center">
        <div fxFlex>
          <button
            *ngIf="intentData.is_custom"
            class="button__text ocean"
            mat-flat-button
            (click)="deleteRulesetPrompt()">
            <img src="/assets/iconography/delete.svg" style="margin-right: 6px" />
            <span>Delete</span>
          </button>
        </div>

        <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
      </div>
    </ng-container>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Guest Experience'">
  <sbnb-gx-subnav></sbnb-gx-subnav>
</sbnb-mobile-sidebar>
